import './UniMenu.scss';
import logoVerde from '../../assets/icons/logo-pos.svg';
import menuHam from '../../assets/icons/menu-ham.svg';
import callCenter from '../../assets/icons/call-center.svg';
import { routesMenu } from '../../routes';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faComment, faIndustry, faLink, faList, faUser, faChartBar, faGear, faChevronDown, faBank } from '@fortawesome/free-solid-svg-icons';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';

interface UniMenuProps {
    activeRoute?: string;
    activeSubRoute?: string;
}

const UniMenu = ({activeRoute, activeSubRoute}: UniMenuProps) => {
    const [extend, setExtend] = useState(false);
    const [expandSubMenu, setExpandSubMenu] = useState('');
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onTouchMenu = (show: boolean = false) => {
        setExtend(show);
    };

    const goToRoute = (route: string) => {
        navigate(`/${route}`);
    }

    const getIcon = (iconName: string): IconProp => {
        switch (iconName) {
            case 'home' :
                return faFileLines;
            case 'newOrder':
                return faFileLines;
            case 'orders':
                return faFileLines;
            case 'links':
                return faLink;
            case 'users':
                return faUser;
            case 'financial':
                return faList;
            case 'customers':
                return faIndustry;
            case 'reports':
                return faChartBar;
            case 'configurations':
                return faGear;
            case 'notifications':
                return faComment;
            case 'banking-account':
                return faBank;
            default :
                return faList;
        }
    }

    const getIconString = (iconName: string) :string => {
        switch (iconName) {            
            case 'callCenter':
                return callCenter;
            default :
                return '';
        }
    }
    return (
        <div>
        <menu
            id='menu'
            className={extend ? 'extend' : ''}
            onPointerOver={() => onTouchMenu(true)}
            onPointerLeave={() => {
                onTouchMenu(false);
                setExpandSubMenu('');
            }}
        >
            <div className={extend ? 'menu-item-on-center' : 'menu-item'}>
                {!extend ? (<img src={menuHam} width={28} style={{marginTop: 20}} alt='logo Unipar verder'/>)
                : (<img src={logoVerde} width={60} style={{marginTop: 20}} className='me-lg-5 on-center' alt='logo Unipar verde'/>)}
            </div>
            {
                routesMenu.map(r => (
                    <>
                        <div
                            className={(activeRoute === r.id ? 'menu-item item-active' : 'menu-item') + (r.children ? ' has-children' : '')}
                            key={r.id}
                            onClick={() => {
                                if (!r.children) {
                                    goToRoute(r.id)
                                }
                            }}
                            onPointerOver={() => setExpandSubMenu(r.id)}
                        >
                            <div className='menu-icon'>
                                {getIconString(r.icon) !== '' ? (
                                    <img src={getIconString(r.icon)} width={28} alt={r.icon} />
                                ) : (
                                    <FontAwesomeIcon icon={getIcon(r.icon)} />
                                )}
                            </div>
                            {extend && (<span>{t(r.translateId)}</span>)}
                            {extend && r.children && (
                                <div className='sub-menu-icon'>
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </div>
                            )}
                        </div>
                        {
                            extend && (activeRoute === r.id || expandSubMenu === r.id) && r.children && r.children.map(c => (
                                <div
                                    className={activeSubRoute === c.id ? 'sub-menu-item item-active' : 'sub-menu-item'}
                                    key={r.id + '-'+ c.id}
                                    onClick={() => goToRoute(r.id + '/' + c.id)}
                                >
                                    {(<span>{t(c.translateId)}</span>)}
                                </div>
                            ))
                        }
                    </>
                ))
            }
        </menu>
        </div>
    )
};

export default UniMenu;